__turbopack_context__.v({
  "radio": "Radio-module__LKBF-G__radio",
  "radioChecked": "Radio-module__LKBF-G__radioChecked",
  "radioDisabled": "Radio-module__LKBF-G__radioDisabled",
  "radioLabel": "Radio-module__LKBF-G__radioLabel",
  "radioPill": "Radio-module__LKBF-G__radioPill",
});
